import { useEffect, useState } from 'react'
import Head from 'next/head'
import Router, { useRouter } from 'next/router'
import Script from 'next/script'
import { ApolloProvider } from '@apollo/client'
import { Box, CircularProgress } from '@mui/material'
import CssBaseline from '@mui/material/CssBaseline'
import { ThemeProvider } from '@mui/material/styles'
import Cookies from 'universal-cookie'
import NextImageWrapper from '../components/images/NextImageWrapper'
import PianoManager from '../components/piano/PianoManager'
import { SALESFORCE_COOKIE } from '../const/cookie'
import '../styles/globals.css'
import { client } from '../lib/apollo-client'
// import * as ga from '../lib/ga'
import * as gtm from '../lib/gtm'
import { theme } from '../styles/mui'

const cookies = new Cookies()

function App({ Component, pageProps }) {
  const [loading, setLoading] = useState(false)
  const { query } = useRouter()
  useEffect(() => {
    /** Using google tag manager for testpageview */
    gtm.testpageview({
      title: pageProps?.SEO?.title ? pageProps?.SEO?.title : document?.title,
      href: pageProps?.SEO?.pageUrl ? pageProps?.SEO?.pageUrl : location?.href,
      path: location?.pathname,
    })
    /**
     * @todo: Need to remove after GA duplication issue is fixed
     */
    // using google analytics
    // ga.pageview({
    //   title: pageProps?.SEO?.title
    //     ? pageProps?.SEO?.title
    //     : document?.title,
    //   href: pageProps?.SEO?.pageUrl
    //     ? pageProps?.SEO?.pageUrl
    //     : location?.href,
    //   path: location?.pathname,
    // })
  }, [pageProps])

  useEffect(() => {
    const sid = cookies.get(SALESFORCE_COOKIE)
    if (!sid) {
      fetch('/api/set-cookie')
        .then((response) => response.json())
        .then((data) => {
          if (data.success) {
            console.log('Cookie has been set.')
          }
        })
    }
  }, [])

  useEffect(() => {
    const pathname = location?.pathname.toLowerCase().replaceAll('_', '-')
    if (pathname !== location?.pathname) {
      setTimeout(() => {
        Router.push(pathname)
      }, 50)
    }
  }, [])

  useEffect(() => {
    if (query?.sid) {
      setLoading(true)
      cookies.set(SALESFORCE_COOKIE, query.sid, {
        path: '/', // Makes the cookie available across the entire site
        sameSite: 'Lax', // Ensures compatibility with modern browser policies
      })
      const returnUrl = sessionStorage.getItem('returnUrl')
      if (returnUrl) {
        sessionStorage.removeItem('returnUrl')
        Router.push(returnUrl).then(() => setLoading(false))
      } else {
        setLoading(false)
      }
    }
  }, [query?.sid])

  return (
    <>
      <Head>
        {process.env.NEXT_PUBLIC_NEXTAUTH_ENV !== 'production' && (
          <>
            <meta name='robots' content='noindex, nofollow' />
            <meta name='googlebot' content='noindex, nofollow' />
          </>
        )}
        <meta
          name='viewport'
          content='minimum-scale=1, initial-scale=1, width=device-width'
        />
        <link rel='icon' type='image/ico' href='/favicon.ico' />
      </Head>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <ApolloProvider client={client}>
          {/* Google Tag Manager - Global base code */}
          <Script
            id='gtag-base'
            strategy='afterInteractive'
            dangerouslySetInnerHTML={{
              __html: `
                  (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                  })(window,document,'script','dataLayer', '${gtm.GTM_ID}');
                `,
            }}
          />
          {loading ? (
            <Box
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
                alignItems: 'center',
              }}
            >
              <NextImageWrapper
                testId='ascd-logo-desktop'
                priority
                src={'/images/logo.svg'}
                alt='ascd logo'
                width={109}
                height={36}
              />
              <CircularProgress />
            </Box>
          ) : (
            <Component {...pageProps} />
          )}
          <PianoManager />
        </ApolloProvider>
      </ThemeProvider>
    </>
  )
}

export default App
